module.exports = function(){
    require('./ngCanvas.directive');
    require('./canvas_directives/drag-canvas');
    require('./canvas_directives/website-engagement');
    require('./canvas_directives/website-activity-condition');
    require('./canvas_directives/add-to-list-entry');
    require('./canvas_directives/add-to-segment-entry');
    require('./canvas_directives/date-and-time');
    require('./canvas_directives/element-menu');
    require('./canvas_directives/editor-menu');
    require('./canvas_directives/add-wait-time-action');
    require('./canvas_directives/send-email-action');
    require('./canvas_directives/add-to-list-action');
    require('./canvas_directives/remove-from-list-action');
    require('./canvas_directives/is-on-list-or-segment');
    require('./canvas_directives/is-in-segment');
    require('./canvas_directives/is-not-in-segment');
    require('./canvas_directives/email-engagement');
    require('./canvas_directives/if-else');
    require('./canvas_directives/element-menu-if-else');
    require('./canvas_directives/facebook-audience');
    require('./canvas_directives/update-field-action');
    require('./canvas_directives/looping-action');
    require('./canvas_active_directives/actions/active-add-wait-time-action');
    require('./canvas_active_directives/actions/active-add-to-list-action');
    require('./canvas_active_directives/actions/active-facebook-audience');
    require('./canvas_active_directives/actions/active-send-email-action');
    require('./canvas_active_directives/actions/active-remove-from-list-action');
    require('./canvas_active_directives/actions/active-update-field-action');
    require('./canvas_active_directives/actions/active-looping-action');
    require('./canvas_active_directives/conditions/active-is-on-list-or-segment');
    require('./canvas_active_directives/conditions/active-in-segment-condition');
    require('./canvas_active_directives/conditions/active-is-not-in-segment');
    require('./canvas_active_directives/conditions/active-website-activity-condition');
    require('./canvas_active_directives/conditions/active-email-engagement');
    require('./canvas_active_directives/conditions/active-rectangle-connector');
    require('./canvas_active_directives/conditions/active-if-else');
    require('./canvas_active_directives/entries/active-website-engagement');
    require('./canvas_active_directives/entries/active-add-to-list-entry');
    require('./canvas_active_directives/entries/active-date-and-time');
    require('./canvas_active_directives/entries/active-add-to-segment-entry');
    require('./canvas_directives/journey-loader');
    require('./canvas_directives/scroll-into');
    require('./ngclipboard');
    require('./angular-chosen');
    require('./modal-dragable');
}();



// WEBPACK FOOTER //
// ./app/directives/index.js